var React = require('react');

function CloseDelete (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M31.9062 2L2 31.9062","stroke":"black","strokeWidth":"3","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M2 2L31.9062 31.9062","stroke":"black","strokeWidth":"3","strokeLinejoin":"round","key":1})]);
}

CloseDelete.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33","fill":"none"};

module.exports = CloseDelete;

CloseDelete.default = CloseDelete;
